import type { TrackedTranslation } from '@ps/web-shared-components';
import React from 'react';
import { useForm } from 'react-final-form';

import { Error } from '../../../../../../types/paymentVerification';
import CTAButton from '../../../../../CTAButton/CTAButton';

interface Props {
  numberOfAddedFiles: number;
  translation: TrackedTranslation;
  setError: (error: Error) => void;
}

const SubmitButton: React.FC<Props> = ({ numberOfAddedFiles, translation, setError }) => {
  const form = useForm();

  const onClick = (e: React.MouseEvent<Element, MouseEvent>) => {
    e.preventDefault();
    if (numberOfAddedFiles === 0) {
      setError(Error.UploadFile);
      return;
    }
    form.submit();
  };

  return <CTAButton translation={translation} type="submit" onClick={onClick} />;
};

SubmitButton.displayName = 'SubmitButton';

export default SubmitButton;
